var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { z } from 'zod';
export var ExperienceLevel = z.nativeEnum({
    New: 'new',
    Medium: 'medium',
    Experienced: 'experienced',
});
export var UserFormSchema = z.object({
    pfp: z.string().min(1, 'Select an avatar'),
    username: z
        .string()
        .min(4, 'Username must contain at least 4 characters')
        .max(20, 'Username can not have more than 20 characters')
        .transform(function (value) { return (!value.startsWith('@') ? "@".concat(value) : value); }),
    first_name: z.string().min(1, 'First name cannot be empty'),
    // last_name: z.string().min(1, 'Last name cannot be empty'),
    experience: ExperienceLevel,
});
export var _checkUsernameAvailability = function (username) { return __awaiter(void 0, void 0, void 0, function () {
    var _waitForThreeSeconds, _url, _res, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _waitForThreeSeconds = function () {
                    return new Promise(function (resolve) {
                        setTimeout(function () { return resolve(); }, 3000);
                    });
                };
                _url = "/api/db/checkUsername?username=".concat(username);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(_url)];
            case 2:
                _res = _a.sent();
                console.log('_checkUsernameAvailability:res', { _res: _res });
                // username has not been taken
                if (_res.status === 404)
                    return [2 /*return*/, true];
                // username has been taken
                if (_res.status === 200)
                    return [2 /*return*/, false];
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.log('_checkUsernameAvailability:error', { error: error_1 });
                throw new Error('error _checkUsernameAvailability');
            case 4: return [2 /*return*/];
        }
    });
}); };
export var _updateDbCloudInfo = function (_data) { return __awaiter(void 0, void 0, void 0, function () {
    var _resp, _result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch('/api/db/setProfile', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(_data),
                })];
            case 1:
                _resp = _a.sent();
                return [4 /*yield*/, _resp.json()];
            case 2:
                _result = _a.sent();
                console.log('_updateDbCloudInfo:result', { _result: _result });
                return [2 /*return*/, { status: _resp.status, data: _result }];
        }
    });
}); };
export var _updateDbProfile = function (_data) { return __awaiter(void 0, void 0, void 0, function () {
    var _resp, _result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch('/api/db/updateProfile', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(_data),
                })];
            case 1:
                _resp = _a.sent();
                return [4 /*yield*/, _resp.json()];
            case 2:
                _result = _a.sent();
                console.log('_updateDbProfile:result ', { _result: _result });
                return [2 /*return*/, { status: _resp.status, data: _result }];
        }
    });
}); };
export var StagesProfileForm;
(function (StagesProfileForm) {
    StagesProfileForm["default"] = "default";
    StagesProfileForm["isCheckingUsername"] = "is checking username";
    StagesProfileForm["isUpdatingAccount"] = "is creating account";
})(StagesProfileForm || (StagesProfileForm = {}));
